import * as React from 'react';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import ComponentRouter from '../../Routes';
import { useState } from 'react';
import AppBars from './AppBar';
import AppDrawer from './Drawer';
import PageLayout from 'components/PageLayout';

export default function ClippedDrawer() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);
  const updateDrawerState = (passedVal: boolean) => {
    setIsDrawerOpen(passedVal);
  };
  const updateDrawerStateFromAppBar = (passedVal: boolean) => {
    setIsDrawerOpen(passedVal);
  };
  const updateHoverState = (passedVal: boolean) => {
    setIsDrawerOpen(passedVal);
  };
  const Token = localStorage.getItem('access');

  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      <CssBaseline />
      <AppBars
        drawerState={isDrawerOpen}
        updateDrawerStateFromAppBar={updateDrawerStateFromAppBar}
        updateHoverState={updateHoverState}
      />
      <AppDrawer drawerState={isDrawerOpen} updateDrawerState={updateDrawerState} />
      <Box
        component='main'
        sx={{
          flexGrow: 1,
          height: '100vh',
          overflow: 'auto',
          p: 3,
        }}
      >
        {Token ? <Toolbar /> : null}
        <PageLayout>
          <ComponentRouter />
        </PageLayout>
      </Box>
    </Box>
  );
}
